module.exports = __webpack_public_path__ + "static/media/ironman.f74675f4.png";